var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFengxiang(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11,
    height: 15
  }, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
    "data-name": "\\u56FE\\u5C42 1",
    width: 11,
    height: 15,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAPCAYAAAAyPTUwAAAA5ElEQVQokXXSrUqEQRTG8Z+iKCaDYDHZxY+gQTAalGWTV2C02DWJybBJy26zGQWLLCqIICxegUWDN2ATX1zlyLywvMw8MHDOM39mzpkzYyedroIOcJq2jnExUQBXcD6SR/w0XoCXM95SCf5s5F9xcl3GDBbxil30cISNtH+G94C3cYVZfCC8Fp6b10UZ3QSGFnCXA2t4vuHNFfr4h3sNbwrTOTjqO8QL1vCAfdxjD6uJu0UV8BCXaYVu0MEbJpM3wFbunX/wOAKG1rFTGsp3xqtKcD/1USvifukjxXg30cYvrlH9AQkYKYf8WfBKAAAAAElFTkSuQmCC"
  })));
}
export default SvgFengxiang;